/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";
import { Table, message } from "antd";
import { useEffect } from "react";

const ImagePreAddress = Url.baseURL[1] + Url.downloadImage;
const ReportFinal = (props) => {
  const Columns = [
    { title: "کد", dataIndex: "id", key: "id" },
    { title: "نام دانشجو", dataIndex: "name", key: "name" },
    {
      title: "شماره دانشجویی",
      dataIndex: "studentCode",
      key: "studentCode",
    },
    // {
    //   title: "بررسی آزمون",
    //   dataIndex: "analyses",
    //   key: "analyses",
    //   render: (_, item) => {
    //     if (item.isSawDemo) {
    //       return (
    //         <Button onClick={() => _onClickAnalysesExam(item)}>
    //           آنالیز آزمون
    //         </Button>
    //       );
    //     }
    //   },
    // },
  ];
  const ColumnsStudent = [
    {
      title: "Patient Id",
      render: (obj, item) => {
        return <div>{item.id}</div>;
      },
    },
    {
      title: "Patient Age",
      render: (obj, item) => {
        return <div>{item.age}</div>;
      },
    },
    {
      title: "maxilla",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "maxilla");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "mandible",
      dataIndex: "mandible",
      key: "mandible",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "mandible");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="mandible"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
  ];
  const _getListStudent = async () => {
    let url = Url.getStudentList;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  useEffect(() => {
    _getListStudent();
  }, []);

  const _onClickRowStudent = async (record) => {
    let url = Url.Professor_getatientOfStudent;

    let res = await props.actions.CallCoreServicesActionWithToken(url, record);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  return (
    <div>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Table
          columns={Columns}
          dataSource={props.coreData[Url.getStudentList]?.[Url.action]?.data}
          loading={props.coreData[Url.getStudentList]?.[Url.action]?.isFetching}
          rowKey={(o) => o.id}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                _onClickRowStudent(record);
              }, // click row
            };
          }}
        />
      </div>

      <div>
        {/* <Table
          columns={ColumnsStudent}
          dataSource={
            props.coreData[Url.Professor_getatientOfStudent]?.[Url.action]?.data
          }
        /> */}
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportFinal);
